<script lang="ts" setup>
import { watch } from 'vue';
// @ts-ignore
import anime from 'animejs/lib/anime.es.js';

const props = defineProps({
  show: {
    type: Boolean,
    required: true
  },
  left: {
    type: Number,
    required: false,
    default: -20
  },
  top: {
    type: Number,
    required: false,
    default: 0
  },
  size: {
    type: String,
    required: false,
    default: 'big'
  }
});

watch(
  () => props.show,
  (show) => {
    if (show) {
      var logoTimeline = anime.timeline({ autoplay: true, direction: 'alternate', loop: false });
      logoTimeline
        .add({
          targets: '.checkmark',
          scale: [{ value: [0, 1], duration: 300, easing: 'easeOutQuad' }]
        })
        .add({
          targets: '.check',
          strokeDashoffset: {
            value: [anime.setDashoffset, 0],
            duration: 300,
            delay: 200,
            easing: 'easeOutQuart'
          },
          translateX: {
            value: [6, 0],
            duration: 300,
            delay: 200,
            easing: 'easeOutQuart'
          },
          translateY: {
            value: [-2, 0],
            duration: 300,
            delay: 200,
            easing: 'easeOutQuart'
          },
          offset: 0
        });
    }
  }
);
</script>
<template>
  <svg
    :class="{ opac: !show }"
    v-if="props.size === 'big'"
    class=""
    :style="{ left: `${left}px`, top: `${top}px` }"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <circle class="circle" cx="16" cy="16" r="16" fill="#4CAF50" />
    <path
      class="check"
      d="M9 16l5 5 9-9"
      fill="none"
      stroke="#fff"
      stroke-width="2.5"
      stroke-linecap="round"
    />
  </svg>
  <svg
    v-else-if="props.size === 'medium'"
    :class="{ opac: !show }"
    class=""
    :style="{ left: `${left}px`, top: `${top}px` }"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <circle class="circle" cx="8" cy="8" r="8" fill="#4CAF50" />
    <path
      class="check"
      d="M4.5 8l2.5 2.5 4.5-4.5"
      fill="none"
      stroke="#fff"
      stroke-width="1.25"
      stroke-linecap="round"
    />
  </svg>
  <svg
    v-else-if="props.size === 'small'"
    :class="{ opac: !show }"
    class=""
    :style="{ left: `${left}px`, top: `${top}px` }"
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="8"
    viewBox="0 0 8 8"
  >
    <circle class="circle" cx="4" cy="4" r="4" fill="#4CAF50" />
    <path
      class="check"
      d="M2 4l1.5 1.5 2-2"
      fill="none"
      stroke="#fff"
      stroke-width="0.625"
      stroke-linecap="round"
    />
  </svg>
</template>
<style scoped></style>
